function trackCustomEvent(eventName, eventData) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
  window.dataLayer.push({
    event: eventName,
    ...eventData,
  });
}

function addToCartEvent(product) {
  trackCustomEvent("add_to_cart", {
    ecommerce: {
      value: parseFloat(product.price / 100).toFixed(2),
      currency: "GBP",
      menu_type: "Shopify",
      items: [
        {
          item_id: product.product_id,
          item_name: product.product_title,
          item_brand: "Shopify",
          item_category: product.product_type,
          price: product.price / 100,
          quantity: 1,
        },
      ],
    },
  });
}

function beginCheckoutEvent(products) {
  const total = products.reduce(
    (acc, product) => acc + product.price * product.quantity,
    0
  );
  trackCustomEvent("begin_checkout", {
    ecommerce: {
      value: parseFloat(total / 100).toFixed(2),
      currency: "GBP",
      coupon: window.Cookies.get("voucherCode") ?? "",
      menu_type: "Shopify",
      items: products.map((product) => ({
        item_id: product.id,
        item_name: product.title,
        item_brand: "Shopify",
        item_category: product.type,
        price: (product.price * product.quantity) / 100,
        quantity: product.quantity,
      })),
    },
  });
}

function viewItemEvent(product) {
  trackCustomEvent("view_item", {
    ecommerce: {
      value: parseFloat(product.price / 100).toFixed(2),
      currency: "GBP",
      menu_type: "Shopify",
      items: [
        {
          item_id: product.id,
          item_name: product.title,
          item_brand: "Shopify",
          item_category: product.type,
          price: product.price / 100,
          quantity: 1,
        },
      ],
    },
  });
}

window.addToCartEvent = addToCartEvent;
